import { Box, Typography } from '@mui/material';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface CargoVistaLogoProps {
  collapsed?: boolean;
}

const CargoVistaLogo: React.FC<CargoVistaLogoProps> = ({ collapsed = false }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
      <Box
        sx={{
          width: 32,
          height: 32,
          flexShrink: 0,
          borderRadius: 1,
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <DirectionsBoatIcon sx={{ fontSize: 18 }} aria-hidden />
      </Box>
      {!collapsed && (
        <Box sx={{ lineHeight: 1, minWidth: 0, textAlign: 'left' }}>
          <Typography
            component="div"
            sx={{ fontSize: 14, fontWeight: 600, letterSpacing: '-0.01em', color: 'text.primary' }}
          >
            {t('common.appName')}
          </Typography>
          <Typography
            component="div"
            sx={{ mt: '2px', fontSize: 11, color: 'text.secondary' }}
          >
            {t('common.appTagline')}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CargoVistaLogo;
